<template>
  <section
    id="home"
    class="bg-primary d-flex fullscreen-with-header position-relative"
  >
    <div class="container my-auto py-5 py-lg-0">
      <div class="row py-4">
        <div
          class="
            col-lg-7
            text-center text-lg-start
            align-self-center
            order-1 order-lg-0
          "
        >
          <h1 class="text-12 mb-0 text-uppercase">
            Hi, I'm a <strong>UI/UX Designer</strong>
          </h1>
          
          <p class="text-5">based in Gujarat, India.</p>
          <a href="#portfolio" class="btn btn-dark rounded-0 smooth-scroll mt-3"
            >View My Works</a
          >
        </div>
        <div
          class="
            col-lg-5
            text-center
            align-self-center
            mb-4 mb-lg-0
            order-0 order-lg-1
          "
        >
          <div
            class="bg-light rounded-pill d-inline-block p-3"
            style="visibility: visible"
            data-aos="zoom-in"
          >
            <img
              class="img-fluid rounded-pill d-block"
              src="@/assets/images/Bhavin_Dabhi.png"
              title="I'm Bhavin Dabhi"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <a href="#about" class="scroll-down-arrow text-dark smooth-scroll"
      ><span class="animated"><i class="fas fa-arrow-down"></i></span
    ></a>
  </section>
  <Aboutme />
  <Service />
  <Resume />
  <Portfolio />
  <Reviewclient/>
</template> 

<script>
import Aboutme from "@/views/Aboutme.vue";
import Service from "@/views/Service.vue";
import Resume from "@/views/Resume.vue";
import Portfolio from "@/views/Portfolio.vue";
import Reviewclient from "@/views/Clientsreview.vue";
export default {
  name: "HomePage",
  components: {
    Aboutme,
    Service,
    Resume,
    Portfolio,
    Reviewclient
  },
  data() {
    return {
      typowrite: ["UI/UX Designer", "Graphic Designer"],
    };
  },
};
</script>

<style scoped>
</style>